/* assets/variant-media-filter.js */

console.log("[variant-media-filter] file loaded", {
  time: new Date().toISOString(),
  url: location.href,
});

(() => {
  const DEBUG = true;
  const log = (...args) => DEBUG && console.log("[VariantMedia]", ...args);

  const STOREFRONT_TOKEN = "a3e7f1ddb2b479292939b534aa568d6b";

  // Cache of variantId -> storefront data, populated eagerly on boot
  const variantCache = {};

  function getCurrentVariant() {
    const sources = [
      "variant-selects [type='application/json']",
      "product-info [type='application/json']",
      "product-form [type='application/json']",
    ];
    for (const sel of sources) {
      const el = document.querySelector(sel);
      if (!el) continue;
      try {
        const data = JSON.parse(el.textContent);
        if (data && !Array.isArray(data) && data.id) return data;
        if (Array.isArray(data)) {
          const idInput = document.querySelector(
            "product-form input[name='id'], form input[name='id']"
          );
          if (idInput) return data.find(v => String(v.id) === String(idInput.value)) || null;
        }
      } catch (e) {
        continue;
      }
    }

    // Fallback for single-variant products where the theme renders no variant
    // picker and no variant JSON — just read the id input directly
    const idInput = document.querySelector("product-form input[name='id'], form input[name='id']");
    if (idInput?.value) {
      return { id: idInput.value, available: true };
    }

    return null;
  }

  // Fetch a single variant from the Storefront API
  async function fetchVariantStorefrontData(variantId) {
    if (variantCache[variantId]) return variantCache[variantId];
    try {
      const gid = `gid://shopify/ProductVariant/${variantId}`;
      const res = await fetch("/api/2024-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
        },
        body: JSON.stringify({
          query: `{
            node(id: "${gid}") {
              ... on ProductVariant {
                id
                availableForSale
                currentlyNotInStock
              }
            }
          }`
        })
      });
      if (!res.ok) return null;
      const json = await res.json();
      const node = json?.data?.node || null;
      if (node) variantCache[variantId] = node;
      return node;
    } catch (e) {
      return null;
    }
  }

  // Fetch ALL variants in a single batched GraphQL query and warm the cache
  async function prefetchAllVariants() {
    try {
      const handle = window.location.pathname.split("/products/")[1]?.split("?")[0];
      if (!handle) return;

      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return;
      const product = await res.json();
      const ids = product.variants.map(v => v.id);

      if (!ids.length) return;

      const aliases = ids.map(
        (id, i) =>
          `v${i}: node(id: "gid://shopify/ProductVariant/${id}") {
            ... on ProductVariant {
              id
              availableForSale
              currentlyNotInStock
            }
          }`
      ).join("\n");

      const gqlRes = await fetch("/api/2024-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query: `{ ${aliases} }` })
      });

      if (!gqlRes.ok) return;
      const json = await gqlRes.json();
      const nodes = json?.data || {};

      Object.values(nodes).forEach(node => {
        if (node?.id) {
          const numericId = node.id.split("/").pop();
          variantCache[numericId] = node;
        }
      });

      log("Prefetched all variants:", Object.keys(variantCache));
    } catch (e) {
      log("Prefetch failed:", e);
    }
  }

  async function updateAddToCartButton() {
    const variant = getCurrentVariant();

    const button = document.querySelector(".product-form__submit");
    if (!button) return;
    const span = button.querySelector("span");
    if (!span) return;

    const preorderMsg = document.getElementById("preorder-message");
    const pickupAvailability = document.querySelector("pickup-availability");

    if (!variant) {
      span.textContent = "Unavailable";
      if (preorderMsg) preorderMsg.style.display = "none";
      return;
    }

    const sfData = await fetchVariantStorefrontData(variant.id);

    log("Storefront variant data:", variant.id, sfData);

    const isPreorder = sfData?.currentlyNotInStock === true && sfData?.availableForSale === true;
    const isSoldOut = sfData ? !sfData.availableForSale : !variant.available;

    if (isPreorder) {
      span.textContent = "Pre-order now";
      button.removeAttribute("disabled");
      if (preorderMsg) {
        preorderMsg.textContent = preorderMsg.dataset.message;
        preorderMsg.style.display = "block";
      }
      if (pickupAvailability) pickupAvailability.style.display = "none";
    } else if (isSoldOut) {
      span.textContent = "Sold out";
      button.setAttribute("disabled", "disabled");
      if (preorderMsg) preorderMsg.style.display = "none";
      if (pickupAvailability) pickupAvailability.style.display = "none";
    } else {
      span.textContent = "Add to cart";
      button.removeAttribute("disabled");
      if (preorderMsg) preorderMsg.style.display = "none";
      if (pickupAvailability) pickupAvailability.style.display = "";
    }
  }

  const normalize = (v) =>
    (v ?? "")
      .toString()
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

  function toColorKeyFromValue(colorValue) {
    const v = (colorValue ?? "").toString().trim();
    if (!v) return "";
    return normalize(`Color: ${v}`);
  }

  function getAltFromMediaItem(el) {
    if (!el) return "";
    const img = el.querySelector("img");
    return (img?.getAttribute("alt") || "").trim();
  }

  function getSectionIdFromGallery(galleryEl) {
    const id = galleryEl?.id || "";
    const parts = id.split("MediaGallery-");
    return parts.length === 2 ? parts[1] : null;
  }

  function getSelectedColorFromVariantPicker(root = document) {
    const selectors = [
      'input[type="radio"][name*="Color"]:checked',
      'input[type="radio"][name*="color"]:checked',
      'select[name*="Color"]',
      'select[name*="color"]',
    ];

    for (const sel of selectors) {
      const el = root.querySelector(sel);
      if (!el) continue;

      if (el.tagName === "SELECT") {
        const opt = el.options?.[el.selectedIndex];
        if (opt?.value) return opt.value;
        if (opt?.textContent) return opt.textContent;
      } else {
        if (el.value) return el.value;
        if (el.dataset?.value) return el.dataset.value;

        const label = root.querySelector(`label[for="${CSS.escape(el.id)}"]`);
        if (label?.textContent) return label.textContent;
      }
    }

    return "";
  }

  function getSelectedColor() {
    const productInfoEl = document.querySelector("product-info");
    return getSelectedColorFromVariantPicker(productInfoEl || document);
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute("hidden", "");
      el.style.display = "none";
    } else {
      el.removeAttribute("hidden");
      el.style.display = "";
    }
  }

  function activateSlide(mediaGalleryEl, slideLi) {
    if (!mediaGalleryEl || !slideLi) return;

    const mediaId = slideLi.getAttribute("data-media-id") || "";

    if (typeof mediaGalleryEl.setActiveMedia === "function" && mediaId) {
      mediaGalleryEl.setActiveMedia(mediaId, true);
      return;
    }

    const sectionId = getSectionIdFromGallery(mediaGalleryEl);
    if (!sectionId || !mediaId) return;

    const thumbBtn = document.querySelector(
      `#GalleryThumbnails-${CSS.escape(sectionId)} button[data-target="${CSS.escape(mediaId)}"]`
    );

    if (thumbBtn) thumbBtn.click();
  }

  function reorderAndFilter(containerEl, items, isMatchFn, isGlobalFn) {
    if (!containerEl) return { visible: [], matching: [], global: [] };

    const matching = [];
    const global = [];
    const hidden = [];

    for (const item of items) {
      const match = isMatchFn(item);
      const glob = isGlobalFn(item);

      if (match) matching.push(item);
      else if (glob) global.push(item);
      else hidden.push(item);
    }

    matching.forEach(el => setHidden(el, false));
    global.forEach(el => setHidden(el, false));
    hidden.forEach(el => setHidden(el, true));

    const ordered = [...matching, ...global, ...hidden];
    ordered.forEach(el => containerEl.appendChild(el));

    return { visible: [...matching, ...global], matching, global };
  }

  function filterOneGallery(mediaGalleryEl) {
    const sectionId = getSectionIdFromGallery(mediaGalleryEl);
    if (!sectionId) return;

    const slidesWrap = document.querySelector(`#Slider-Gallery-${CSS.escape(sectionId)}`);
    const thumbsWrap = document.querySelector(`#Slider-Thumbnails-${CSS.escape(sectionId)}`);

    if (!slidesWrap) return;

    const slides = Array.from(slidesWrap.querySelectorAll("li.product__media-item"));
    const thumbs = thumbsWrap
      ? Array.from(thumbsWrap.querySelectorAll("li.thumbnail-list__item"))
      : [];

    const selectedKey = toColorKeyFromValue(getSelectedColor());

    if (!selectedKey) {
      slides.forEach(li => setHidden(li, false));
      thumbs.forEach(li => setHidden(li, false));
      return;
    }

    const isMatch = li => normalize(getAltFromMediaItem(li)) === selectedKey;
    const isGlobal = li => normalize(getAltFromMediaItem(li)) === "global";

    const slidesResult = reorderAndFilter(slidesWrap, slides, isMatch, isGlobal);
    reorderAndFilter(thumbsWrap, thumbs, isMatch, isGlobal);

    const firstToActivate = slidesResult.matching[0] || slidesResult.global[0];

    if (firstToActivate) {
      const isInitial = !mediaGalleryEl.dataset.initialized;

      if (isInitial) {
        setTimeout(() => activateSlide(mediaGalleryEl, firstToActivate), 150);
        mediaGalleryEl.dataset.initialized = "true";
      } else {
        activateSlide(mediaGalleryEl, firstToActivate);
      }
    }
  }

  function filterAllGalleries() {
    const galleries = document.querySelectorAll("media-gallery[id^='MediaGallery-']");
    galleries.forEach(filterOneGallery);
  }

  function boot() {
    log("Booted");

    filterAllGalleries();

    // Prefetch all variant data first, then update the button so the
    // cache is always warm before we read from it
    prefetchAllVariants().then(() => {
      updateAddToCartButton();
    });

    const productForm = document.querySelector("product-form");

    const handleVariantChange = () => {
      setTimeout(() => {
        updateAddToCartButton();
        filterAllGalleries();
      }, 100);
    };

    if (productForm) {
      productForm.addEventListener("variant:changed", handleVariantChange);
    }

    document.addEventListener("variant:changed", handleVariantChange);
    document.addEventListener("variant:change", handleVariantChange);
    document.addEventListener("variantChange", handleVariantChange);

    document.addEventListener("change", (e) => {
      if (e.target.name === "id" || e.target.closest("variant-radios, variant-selects")) {
        setTimeout(() => {
          updateAddToCartButton();
          filterAllGalleries();
        }, 100);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();